import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {ActivatedRoute, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {FormsModule} from '@angular/forms';
import {TranslocoModule} from '@ngneat/transloco';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    TranslocoModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchComponent implements OnInit, OnDestroy {
  @Output() queryChange = new EventEmitter<string>();

  @Input() query = '';
  @Input() placeholder = '';
  @Input() routeChange = true;
  @Input() routeListen = true;

  @ViewChild('input') inputRef: ElementRef<HTMLInputElement>;

  loading = false;

  subs = new Subscription();

  private router = inject(Router);
  private route = inject(ActivatedRoute);

  ngOnInit(): void {
    if (this.routeListen) {
      this.subs.add(
        this.route.queryParams.subscribe(qp => {
          this.query = qp.q || '';
        })
      );
    }

    if (this.routeChange) {
      this.subs.add(
        this.queryChange.pipe(
          debounceTime(250),
          distinctUntilChanged()
        ).subscribe(async () => {
          await this.router.navigate([], {queryParams: {q: this.query.length > 0 ? this.query : null}, queryParamsHandling: 'merge'});
        })
      );
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  clear() {
    this.query = '';
    this.queryChange.emit('');
  }
}
